import { createFileRoute, useSearch } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { AlertTriangle } from "tabler-icons-react";
import LogOutButton from "@/components/common/Buttons/LogOutButton";
import { servicesOrchestratorValues } from "@/config/services";
import { visionSearchParamsSchema } from "@/routes/-search-params";
import { getSearchParam } from "@/utils/searchParams";

export const Route = createFileRoute("/$locale/error")({
	validateSearch: (search) => visionSearchParamsSchema.parse(search),
	component: ErrorPage,
});

function getErrorMessage(code: string | undefined) {
	switch (code) {
		case "access_denied":
			return "Access to this app is not available for your account";
		default:
			return "Something went wrong";
	}
}

function ErrorPage() {
	const { t } = useTranslation();
	const search = useSearch({ strict: false });
	const message = getErrorMessage(getSearchParam(search, "code"));
	const logoUrl = `${servicesOrchestratorValues.urls.cdn}/partner-assets/default/pandas-logo-black.svg`;

	return (
		<div className="h-[100dvh] w-[100dvw] overflow-hidden flex flex-col bg-zinc-100 transition-all duration-500 ease-in-out sm:px-10 sm:pb-10">
			<div className="transition-all duration-500 ease-in-out flex flex-row items-center px-4 py-3 sm:py-4 justify-between z-50">
				<img
					src={logoUrl}
					alt="logo"
					className="h-8"
				/>
				<LogOutButton alwaysVisible />
			</div>
			<div className="flex flex-col w-full h-screen-minus-58 sm:h-screen-minus-64 sm:rounded-xl bg-white items-center justify-center text-center gap-2 pb-20">
				<AlertTriangle
					className="w-24 h-24 lg:w-40 lg:h-40"
					strokeWidth={1.2}
				/>
				<h3 className="w-[90%] max-w-[680px]">{t(`Error.${message}`, message)}</h3>
			</div>
		</div>
	);
}
